import { render, staticRenderFns } from "./ImperialSystemButton.vue?vue&type=template&id=0328f7a2"
import script from "./ImperialSystemButton.vue?vue&type=script&lang=js"
export * from "./ImperialSystemButton.vue?vue&type=script&lang=js"
import style0 from "./ImperialSystemButton.vue?vue&type=style&index=0&id=0328f7a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports